// extracted by mini-css-extract-plugin
module.exports = {"text":"info-banner_text__pf_8C"};